import { Button } from "react-bootstrap";

import { DateTime } from "luxon";
import { ScrollPanel } from "primereact/scrollpanel";
import { Timeline } from "primereact/timeline";

import ColoredMarker from "./ColoredMarker.tsx";
import {
  getHistoryStatusValuesByType,
  HistoryActionType,
} from "../../_constants/historyType.ts";
import { getDateFromIso } from "../../_helpers/stringHelper.ts";
import { History } from "../../modules/serviceOrdering/reducers";

// Extended History interface to include user properties that are actually returned by the API
interface ExtendedHistory extends History {
  user?: {
    id: string;
    fullName: string;
  };
  actionUser?: {
    id: string;
    fullName: string;
  };
}

interface HistoryTimelineProps {
  histories: ExtendedHistory[];
  refetch: () => void;
  isFetching: boolean;
}

interface TimelineEvent {
  status: string;
  date: string;
  icon: string;
  color: string;
  text: string;
  fullDate: string;
}

export const HistoryTimelineComponent = ({
  refetch,
  histories,
  isFetching,
}: HistoryTimelineProps) => {
  const lastUser = histories
    ?.filter(
      (history) =>
        history.action === HistoryActionType.CREATE ||
        history.action === HistoryActionType.UPDATE_STATUS
    )
    ?.pop()?.user;

  const events: TimelineEvent[] = histories?.map((history) => {
    const historyStatus = getHistoryStatusValuesByType(history.action);
    const user = history?.user || history?.actionUser || lastUser;

    return {
      status: historyStatus?.status || "",
      date: getDateFromIso(history.createdAt, DateTime.DATETIME_SHORT),
      fullDate: history?.createdAt,
      icon: historyStatus?.icon,
      color: historyStatus?.color,
      text: history?.text,
      user,
    };
  });

  return (
    <>
      <div
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          zIndex: 9999,
        }}
      >
        <Button
          size="lg"
          variant="link"
          className={isFetching ? "refresh-arrow btn-arrow" : "btn-arrow"}
          onClick={refetch}
        >
          <i className="bi bi-arrow-repeat arrow-dashboard"></i>
        </Button>
      </div>
      <div className="position-relative border-left pb-3">
        <ScrollPanel className="position-absolute molten-container h-100">
          <Timeline
            className={"timeline-history"}
            value={events}
            opposite={(item) => (
              <ColoredMarker
                className="text-no-wrap"
                color={item.color}
                tooltip={item.text}
                tooltipOptions={{ position: "left" }}
              >
                {item.status}
              </ColoredMarker>
            )}
            content={(item) => (
              <div style={{ width: "175px" }}>
                <label className="orderPage" title={item.fullDate}>
                  {item.date}
                </label>
                <div className="small-font-size">
                  {`Par ${item?.user?.fullName || "Inconnu"}`}
                </div>
              </div>
            )}
            marker={(item) => (
              <span className="p-2">
                <i
                  className={`pi ${item.icon}`}
                  style={{ color: item.color }}
                ></i>
              </span>
            )}
          />
        </ScrollPanel>
      </div>
    </>
  );
};

export default HistoryTimelineComponent;
